import { ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router-dom';

import appThemeV2 from 'theme/themeV2';

const OrganizationLayout = () => (
    <ThemeProvider theme={appThemeV2}>
        <Outlet />
    </ThemeProvider>
);

export default OrganizationLayout;
